var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8628_57089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5918 23.7274V34.9583H45.5177C44.8183 38.5702 42.7197 41.6285 39.5723 43.6848L49.1762 50.9877C54.7718 45.926 58 38.4913 58 29.6595C58 27.6032 57.8117 25.6257 57.4619 23.7277L29.5918 23.7274Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0077 34.5199L10.8416 36.1448L3.17447 41.9975C8.04369 51.462 18.0235 58.0003 29.5912 58.0003C37.5809 58.0003 44.2793 55.4166 49.1756 50.9876L39.5717 43.6848C36.9353 45.4248 33.5725 46.4795 29.5912 46.4795C21.8973 46.4795 15.3604 41.3913 13.0198 34.5366L13.0077 34.5199Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17446 16.0028C1.15693 19.9045 0.000274658 24.3073 0.000274658 29C0.000274658 33.6926 1.15693 38.0955 3.17446 41.9972C3.17446 42.0233 13.0207 34.5098 13.0207 34.5098C12.4289 32.7698 12.079 30.9245 12.079 28.9997C12.079 27.0749 12.4289 25.2295 13.0207 23.4895L3.17446 16.0028Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5918 11.5473C33.95 11.5473 37.8238 13.0237 40.9175 15.871L49.3915 7.5665C44.2532 2.87383 37.5818 0 29.5918 0C18.0241 0 8.04369 6.51184 3.17447 16.0028L13.0204 23.4902C15.3607 16.6355 21.8979 11.5473 29.5918 11.5473Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8628_57089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.cc9e4a1cba70d2a58cb40da389f19248.svg";
export { ForwardRef as ReactComponent };